import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('@/views/contract.vue')
    },
    {
      path: '/import',
      name: 'import',
      component: () => import('@/views/users/import.vue')
    },
    {
      path: '/posts',
      name: 'posts',
      component: () => import('@/views/posts.vue')
    },
    {
      path: '/problems',
      name: 'problems',
      component: () => import('@/views/problems.vue')
    },
    {
      path: '/reset-camp',
      name: 'reset-camp',
      component: () => import('@/views/users/reset-camp.vue')
    },
    {
      path: '/orders-1',
      name: 'orders-1',
      component: () => import('@/views/orders-1.vue')
    },
    {
      path: '/orders-2',
      name: 'orders-2',
      component: () => import('@/views/orders-2.vue')
    },
    {
      path: '/tasks2',
      name: 'tasks2',
      component: () => import('@/views/tasks2.vue')
    },
    {
      path: '/tasks2-users',
      name: 'tasks2-users',
      component: () => import('@/views/tasks2-users.vue')
    },
    {
      path: '/orders-2',
      name: 'orders-2',
      component: () => import('@/views/orders-2.vue')
    },
    {
      path: '/busses',
      name: 'busses',
      component: () => import('@/views/busses.vue')
    },
    {
      path: '/ques',
      name: 'ques',
      component: () => import('@/views/ques.vue')
    },
    {
      path: '/arrange-problem',
      name: 'arrange-problem',
      component: () => import('@/views/arrange-problem.vue')
    },
    {
      path: '/trips',
      name: 'trips',
      component: () => import('@/views/trips.vue')
    },
    {
      path: '/awareness',
      name: 'awareness',
      component: () => import('@/views/awareness.vue')
    },
    {
      path: '/awareness-users',
      name: 'awareness-users',
      component: () => import('@/views/awareness-users.vue')
    },
    {
      path: '/stats',
      name: 'stats',
      component: () => import('@/views/stats.vue')
    },
    {
      path: '/iamlost',
      name: 'iamlost',
      component: () => import('@/views/iamlost.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/users/search.vue')
    },
    {
      path: '/tafwij-1',
      name: 'tafwij-1',
      component: () => import('@/views/tafwij-1.vue')
    },
    {
      path: '/tafwij-2',
      name: 'tafwij-2',
      component: () => import('@/views/tafwij-2.vue')
    },
    {
      path: '/asks',
      name: 'asks',
      component: () => import('@/views/asks.vue')
    },
    {
      path: '/docs',
      name: 'docs',
      component: () => import('@/views/docs.vue')
    },
    {
      path: '/send',
      name: 'send',
      component: () => import('@/views/users/send.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings.vue')
    },
    {
      path: '/devs',
      name: 'devs',
      component: () => import('@/views/devs.vue')
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/views/admins.vue')
    },
    {
      path: '/camps',
      name: 'camps',
      component: () => import('@/views/camps.vue')
    },
    {
      path: '/scan',
      name: 'scan',
      component: () => import('@/views/scan.vue')
    },
    {
      path: '/arrange-bus',
      name: 'arrange-bus',
      component: () => import('@/views/arrange-bus.vue')
    },
    {
      path: '/arrange-camp',
      name: 'arrange-camp',
      component: () => import('@/views/arrange-camp.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/users/list.vue')
    },
    {
      path: '/users/add',
      name: 'users-add',
      component: () => import('@/views/users/add.vue')
    },
    {
      path: '/forms',
      name: 'forms',
      component: () => import('@/views/forms.vue')
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import('@/views/tasks.vue')
    },
    {
      path: '/commitments',
      name: 'commitments',
      component: () => import('@/views/commitments.vue')
    },
    {
      path: '/cards-register',
      name: 'cards-register',
      component: () => import('@/views/cards-register.vue')
    },
    {
      path: '/cards-done',
      name: 'cards-done',
      component: () => import('@/views/cards-done.vue')
    },
    {
      path: '/accepted-forms',
      name: 'accepted-forms',
      component: () => import('@/views/accepted-forms.vue')
    },
    {
      path: '/rate-all',
      name: 'rate-all',
      component: () => import('@/views/rate-all.vue')
    },
    {
      path: '/rate-section',
      name: 'rate-section',
      component: () => import('@/views/rate-section.vue')
    },
    {
      path: '/add-ticket',
      name: 'add-ticket',
      component: () => import('@/views/add-ticket.vue')
    },
    {
      path: '/view-tickets',
      name: 'view-tickets',
      component: () => import('@/views/view-tickets.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/pages/logout.vue')
    },
    {
      path: '/otp',
      name: 'otp',
      component: () => import('@/views/otp.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      name: 'error-4042',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
